import React, { useEffect, useState } from 'react';

//MaterialUI
import { makeStyles  } from "@material-ui/core/styles";
import { IconButton, Tooltip } from '@material-ui/core';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';

//Materil UI Icons
import ReplayCircleFilledRoundedIcon from '@mui/icons-material/ReplayCircleFilledRounded';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';

//Router dome
import { Link, Redirect } from "react-router-dom";

//redux
import { useSelector, useDispatch } from 'react-redux';
import { setUsersRedux } from '../../store/actions'

//Components
import { WhiteButton } from '../../utils/Buttons';
import Logos from '../../components/user/Logos'

//upload data
import firebase from '../../database/firebase'

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

//CSS
const useStyles = makeStyles((theme) =>({
    backgroundContainer: {
        backgroundImage: 'url(/./img/login/background.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        position: 'relative',
        width: '100vw',
        maxWidth: '100vw',
        minHeight: '100vh',
        textAlign: 'center',
    },
    overlay: {
        minWidth: '100vw',
        minHeight: '100vh',
        backgroundImage: 'linear-gradient(180deg, #0E191C 30%, #0E191C 53%, #0E191C 100%)',
        paddingTop: 30,
        paddingBottom: 50,
        textAlign: 'center',
        color: 'white',
    },
    title: {
        fontSize: '25px',
        fontWeight: 'bold',
        marginBottom: 20,
        marginTop: 30
    },
    subtitle: {
        fontSize: '28px',
        marginBottom: 20,
        marginTop: 40,
        fontWeight: 'bold',
        color: 'white',
    },

    /* action buttons */
    actionButtons: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridGap: 20,
        marginTop: 50,
        width: '70%',
        maxWidth: '600px',
        margin: 'auto',
        marginBottom: 30,
    },
    link: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'none',
        }
    },

    /* toolbar */
    toolbar: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
        marginBottom: 24,
        width: '90%',
        maxWidth: '800px',
        margin: '0 auto 24px auto',
    },
    filterInput: {
        flex: 1,
        minWidth: 200,
        maxWidth: 400,
        padding: '12px 20px',
        outline: 'none',
        borderRadius: '45px',
        border: '1px solid rgba(255,255,255,0.3)',
        background: "rgba(255,255,255,0.05)",
        color: 'white',
        fontSize: 14,
        transition: 'border-color 0.2s',
        '&:focus': {
            borderColor: 'rgba(255,255,255,0.6)',
        },
        '&::placeholder': {
            color: 'rgba(255,255,255,0.5)'
        }
    },
    numUsers: {
        fontSize: '16px',
        fontWeight: 'bold',
        color: 'rgba(255,255,255,0.7)',
        marginBottom: 0,
    },
    iconButton: {
        color: 'rgba(255,255,255,0.7)',
        transition: 'all 0.2s',
        '&:hover': {
            color: 'white',
            transform: 'scale(1.1)',
        }
    },

    /* user cards */
    usersContainer: {
        width: '95%',
        maxWidth: '900px',
        margin: '0 auto',
    },
    userCard: {
        background: 'rgba(255,255,255,0.06)',
        borderRadius: 12,
        padding: '16px 20px',
        marginBottom: 8,
        transition: 'background 0.2s',
        '&:hover': {
            background: 'rgba(255,255,255,0.09)',
        }
    },
    userCardHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        [theme.breakpoints.down('600')]: {
            flexWrap: 'wrap',
        }
    },
    userInfo: {
        flex: 1,
        minWidth: 0,
        textAlign: 'left',
    },
    userName: {
        fontSize: 16,
        fontWeight: 'bold',
        color: 'white',
        marginBottom: 2,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    userEmail: {
        fontSize: 13,
        color: 'rgba(255,255,255,0.55)',
        marginBottom: 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    userMeta: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        flexShrink: 0,
        [theme.breakpoints.down('600')]: {
            width: '100%',
            marginTop: 10,
            justifyContent: 'space-between',
        }
    },
    metaItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: 50,
    },
    metaLabel: {
        fontSize: 10,
        color: 'rgba(255,255,255,0.4)',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        letterSpacing: 0.5,
        marginBottom: 2,
    },
    metaValue: {
        fontSize: 14,
        color: 'white',
        fontWeight: 'bold',
        marginBottom: 0,
    },
    codeContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
    },
    codeText: {
        fontSize: 13,
        color: 'rgba(255,255,255,0.7)',
        fontFamily: 'monospace',
        letterSpacing: 1,
        marginBottom: 0,
    },
    copyBtn: {
        color: 'rgba(255,255,255,0.4)',
        padding: 4,
        '&:hover': {
            color: 'white',
        }
    },
    expandBtn: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        gap: 2,
        padding: '2px 8px',
        borderRadius: 20,
        background: 'rgba(255,255,255,0.08)',
        transition: 'background 0.2s',
        '&:hover': {
            background: 'rgba(255,255,255,0.15)',
        }
    },
    expandBtnText: {
        fontSize: 13,
        color: 'white',
        fontWeight: 'bold',
        marginBottom: 0,
    },
    paidInput: {
        background: 'rgba(255,255,255,0.08)',
        outline: 'none',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: 8,
        color: 'white',
        width: 44,
        padding: '6px 8px',
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'center',
        transition: 'border-color 0.2s',
        '&:focus': {
            borderColor: 'rgba(255,255,255,0.5)',
        }
    },
    divider: {
        width: 1,
        height: 32,
        background: 'rgba(255,255,255,0.1)',
    },

    /* Referral inline table */
    expandPanel: {
        margin: '10px 0 4px 0',
        padding: '12px 16px',
        background: 'rgba(255,255,255,0.04)',
        borderRadius: 10,
    },
    expandPanelTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: 'rgba(255,255,255,0.5)',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginBottom: 8,
        textAlign: 'left',
    },
    referralRow: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr 1fr 70px',
        alignItems: 'center',
        padding: '6px 0',
        gap: '10px',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    referralHeader: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr 1fr 70px',
        alignItems: 'center',
        padding: '4px 0 8px 0',
        gap: '10px',
        borderBottom: '1px solid rgba(255,255,255,0.15)',
    },
    referralText: {
        fontSize: '13px',
        color: 'rgba(255,255,255,0.8)',
        marginBottom: 0,
        textAlign: 'left',
        wordBreak: 'break-all',
    },
    referralLabel: {
        fontSize: '11px',
        color: 'rgba(255,255,255,0.4)',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginBottom: 0,
        textAlign: 'left',
    },
    saveReferralBtn: {
        marginTop: 10,
        textAlign: 'right',
    },

    /* Teams inline panel */
    teamBlock: {
        marginBottom: 12,
        '&:last-child': {
            marginBottom: 0
        }
    },
    teamTitle: {
        fontSize: '12px',
        fontWeight: 'bold',
        color: 'rgba(255,255,255,0.5)',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        marginBottom: 6,
        textAlign: 'left',
    },
    teamPlayersContainer: {
        display: 'flex',
        overflowX: 'scroll',
        padding: '6px 0',
        marginBottom: '6px',
    },
    teamPlayerContainer: {
        background: 'none',
        minWidth: '80px',
        marginRight: '16px',
        padding: '5px',
        borderRadius: '10px',
    },
    teamPlayerImg: {
        width: '60px',
        height: '60px',
        margin: 'auto',
        marginBottom: 5,
        borderRadius: '50%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    },
    teamPlayerName: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
    },
    teamPlayerType: {
        color: 'white',
        fontSize: '12px',
        opacity: 0.75,
        textAlign: 'center',
    },
}))

export default function Users({classes}) {
    classes = useStyles();

    //redux
    const dispatch = useDispatch()
    const user = useSelector(state => state.userState.user);
    const users = useSelector(state => state.usersState.users);

    //state
    const [usersList, setUsersList] = useState([])
    const [filter, setFilter] = useState('')
    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState('')
    const [severity, setSeverity] = useState('success')
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)

    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);

    // Referral state
    const [allReferrals, setAllReferrals] = useState([])
    const [expandedUser, setExpandedUser] = useState(null)
    const [modifiedReferrals, setModifiedReferrals] = useState({})

    // Teams state
    const [expandedTeamsUser, setExpandedTeamsUser] = useState(null)

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleMenuCloseClick = (num) => {
        setAnchorEl(null);
        if(num === 0){
            setUsersList(users)
        } else if(num === 1){
            setUsersList(users.filter(user => user.hasPaid !== true))
        } else if(num === 2) {
            setUsersList(users.filter(user => user.hasPaid === true))
        } else if(num === 3){
            setUsersList(users.filter(user => user.hasSelected === true))
        } else {
            setUsersList(users.filter(user => user.hasSelected !== true))
        }
    }

    const fecthUsersFirebase =  (flag) => {
        if(flag === true){
            let data = []
            firebase.db.collection('users')
                .where('type', '==', 'user')
                .onSnapshot(snapshot => {
                    snapshot.docs.forEach(doc => {
                        data.push({
                            ...doc.data(),
                            edited: false,
                        })
                    })
                    //filter data for unique uid
                    let unique = [...new Map(data.map(item => [item.uid, item])).values()]

                    localStorage.setItem('reduxUsers', JSON.stringify(unique))
                    dispatch(setUsersRedux(unique))
                    setUsersList(unique)
                })
        }
    }

    // Fetch all referrals
    useEffect(() => {
        const unsub = firebase.db.collection('referrals').onSnapshot(snapshot => {
            const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
            setAllReferrals(data)
        })
        return unsub
    }, [])

    useEffect(() => {
        if(users) {
            setUsersList(users);
        } else {
            fecthUsersFirebase(true)
        }
    },[])

    const handleFilterChange = (e) => {
        setFilter(e.target.value)
        let data = users.filter(user => user.email.toLowerCase().includes(e.target.value.toLowerCase()))
        setUsersList(data)
    }

    const handleUserChange = (uid, paidTeams) => {
        let data = [...users]
        let index = data.findIndex(user => user.uid === uid)

        data[index].edited = true
        data[index].paidTeams = Number(paidTeams)

        data[index].hasPaid = Number(paidTeams) > 0

        localStorage.setItem('reduxUsers', JSON.stringify(data))
        dispatch(setUsersRedux(data))

        if(filter !== "") {
            data = users.filter(user => user.email.toLowerCase().includes(filter.toLowerCase()))
        }
        setUsersList(data)
    }

    const handleSaveUsers = (e) => {
        e.preventDefault()
        let data = [...users]
        data.forEach(item => {
            if(item.edited) {
                firebase.db.collection('users').doc(item.uid).update({
                    paidTeams: item.paidTeams,
                    hasPaid: item.hasPaid
                })
            }
        })
        localStorage.setItem('reduxUsers', JSON.stringify(data))
        setOpen(true)
        setSeverity('success')
        setMessage('Usuarios actualizados exitosamente')
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }

        setOpen(false);
    };

    const handleResetUsers = () => {
        setConfirmDialogOpen(true)
    }

    const handleConfirmReset = () => {
        let data = [...users]
        data.forEach(user => {
            firebase.db.collection('users').doc(user.uid).set({
                hasPaid: false,
                hasSelected: false,
                nickname: user.nickname,
                phone: user.phone,
                email: user.email,
                type: user.type,
                uid: user.uid,
                paidTeams: 0,
                numTeams: 0,
                referralCode: user.referralCode || '',
                referredBy: user.referredBy || null
            }).then(() => {
                setOpen(true)
                setSeverity('success')
                setMessage('Usuario reseteados exitosamente')
            }).catch(() => {
                setOpen(true)
                setSeverity('error')
                setMessage('Error al resetear usuarios')
            })
        })
        localStorage.setItem('reduxUsers', JSON.stringify(data))
        setConfirmDialogOpen(false)
    }

    // Get referral count for a user
    const getReferralCount = (uid) => {
        return allReferrals.filter(r => r.referrerUid === uid).length
    }

    // Get referrals for a user
    const getUserReferrals = (uid) => {
        return allReferrals.filter(r => r.referrerUid === uid)
    }

    // Toggle expanded user
    const handleToggleExpand = (uid) => {
        setExpandedUser(prev => prev === uid ? null : uid)
        setModifiedReferrals({})
    }

    // Toggle isPaid for a referral
    const handleTogglePaid = (referralId, currentValue) => {
        setModifiedReferrals(prev => ({
            ...prev,
            [referralId]: !currentValue
        }))
    }

    // Toggle expanded teams user
    const handleToggleTeams = (uid) => {
        setExpandedTeamsUser(prev => prev === uid ? null : uid)
    }

    // Get all teams for a user (primary + additional)
    const getAllTeams = (u) => {
        const teams = []
        if (u.data) {
            teams.push({ num: 1, team: u.data })
        }
        if (u.teams && u.teams.length > 0) {
            u.teams.forEach(t => {
                teams.push({ num: t.num, team: t.team })
            })
        }
        return teams
    }

    // Save referral payment changes
    const handleSaveReferrals = async () => {
        for (const [referralId, isPaid] of Object.entries(modifiedReferrals)) {
            await firebase.db.collection('referrals').doc(referralId).update({
                isPaid: isPaid,
                paidAt: isPaid ? firebase.firebase.firestore.FieldValue.serverTimestamp() : null
            })
        }
        setModifiedReferrals({})
        setOpen(true)
        setSeverity('success')
        setMessage('Pagos de referidos actualizados')
    }

    const handleCopyCode = (code) => {
        navigator.clipboard.writeText(code)
        setOpen(true)
        setSeverity('success')
        setMessage('Codigo copiado')
    }

    return (
        <div>
            {!user && (
                <Redirect to="/"/>
            )}
            {user && user.type !== 'admin' && (
                <Redirect to="/inicio"/>
            )}
            <div className={classes.backgroundContainer}>
                <div className={classes.overlay}>
                    {/* header */}
                    <Logos/>
                    <h1 className={classes.title}>Bienvenido {user && user.nickname}</h1>

                    {/* action buttons */}
                    <div className={classes.actionButtons}>
                        <Link to="/admin" className={classes.link}><WhiteButton>Regresar</WhiteButton></Link>
                    </div>

                    {/* editar usuarios */}
                    <h2 className={classes.subtitle}>Usuarios</h2>

                    {/* Toolbar */}
                    <div className={classes.toolbar}>
                        <input
                            className={classes.filterInput}
                            placeholder="Buscar por email..."
                            value={filter}
                            onChange={handleFilterChange}
                        />
                        {users && (
                            <p className={classes.numUsers}>{usersList.length}/{users.length}</p>
                        )}
                        <IconButton className={classes.iconButton} onClick={() => {fecthUsersFirebase(true)}}>
                            <ReplayCircleFilledRoundedIcon fontSize="small"/>
                        </IconButton>
                        <IconButton
                            className={classes.iconButton}
                            id="fade-button"
                            aria-controls={menuOpen ? 'fade-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={menuOpen ? 'true' : undefined}
                            onClick={handleMenuClick}
                        >
                            <FilterListRoundedIcon fontSize="small"/>
                        </IconButton>
                        <Tooltip title="Resetear usuarios" placement='top'>
                            <IconButton className={classes.iconButton} onClick={handleResetUsers}>
                                <DeleteRoundedIcon fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                        <Menu
                            id="fade-menu"
                            MenuListProps={{
                            'aria-labelledby': 'fade-button',
                            }}
                            anchorEl={anchorEl}
                            open={menuOpen}
                            onClose={handleMenuClose}
                            TransitionComponent={Fade}
                        >
                            <MenuItem onClick={() => {handleMenuCloseClick(0)}}>Todos</MenuItem>
                            <MenuItem onClick={() => {handleMenuCloseClick(1)}}>No han pagado</MenuItem>
                            <MenuItem onClick={() => {handleMenuCloseClick(2)}}>Ya pagaron</MenuItem>
                            <MenuItem onClick={() => {handleMenuCloseClick(3)}}>Ya tienen equipo</MenuItem>
                            <MenuItem onClick={() => {handleMenuCloseClick(4)}}>No tienen equipo</MenuItem>
                        </Menu>
                    </div>

                    {/* User cards */}
                    <div className={classes.usersContainer}>
                        {usersList.length !== 0 && usersList.map((u, index) => {
                            const refCount = getReferralCount(u.uid)
                            const isExpanded = expandedUser === u.uid
                            const userReferrals = isExpanded ? getUserReferrals(u.uid) : []
                            const teamCount = u.hasSelected ? (u.numTeams || 1) : 0
                            const isTeamsExpanded = expandedTeamsUser === u.uid

                            return (
                                <div key={index} className={classes.userCard}>
                                    <div className={classes.userCardHeader}>
                                        {/* User info */}
                                        <div className={classes.userInfo}>
                                            <p className={classes.userName}>{u.nickname}</p>
                                            <p className={classes.userEmail}>{u.email} {u.phone ? `| ${u.phone}` : ''}</p>
                                        </div>

                                        <div className={classes.userMeta}>
                                            {/* Referral code */}
                                            {u.referralCode && (
                                                <div className={classes.codeContainer}>
                                                    <p className={classes.codeText}>{u.referralCode}</p>
                                                    <IconButton className={classes.copyBtn} size="small" onClick={() => handleCopyCode(u.referralCode)}>
                                                        <ContentCopyRoundedIcon style={{fontSize: 14}}/>
                                                    </IconButton>
                                                </div>
                                            )}

                                            <div className={classes.divider}/>

                                            {/* Referrals */}
                                            <div className={classes.metaItem}>
                                                <span className={classes.metaLabel}>Refs</span>
                                                {refCount > 0 ? (
                                                    <div className={classes.expandBtn} onClick={() => handleToggleExpand(u.uid)}>
                                                        <p className={classes.expandBtnText}>{refCount}</p>
                                                        {isExpanded
                                                            ? <ExpandLessRoundedIcon style={{color: 'white', fontSize: 16}}/>
                                                            : <ExpandMoreRoundedIcon style={{color: 'white', fontSize: 16}}/>
                                                        }
                                                    </div>
                                                ) : (
                                                    <p className={classes.metaValue}>0</p>
                                                )}
                                            </div>

                                            {/* Teams */}
                                            <div className={classes.metaItem}>
                                                <span className={classes.metaLabel}>Equipos</span>
                                                {teamCount > 0 ? (
                                                    <div className={classes.expandBtn} onClick={() => handleToggleTeams(u.uid)}>
                                                        <p className={classes.expandBtnText}>{teamCount}</p>
                                                        {isTeamsExpanded
                                                            ? <ExpandLessRoundedIcon style={{color: 'white', fontSize: 16}}/>
                                                            : <ExpandMoreRoundedIcon style={{color: 'white', fontSize: 16}}/>
                                                        }
                                                    </div>
                                                ) : (
                                                    <p className={classes.metaValue}>0</p>
                                                )}
                                            </div>

                                            <div className={classes.divider}/>

                                            {/* Paid teams */}
                                            <div className={classes.metaItem}>
                                                <span className={classes.metaLabel}>Pago</span>
                                                <input
                                                    type="number"
                                                    value={u.paidTeams}
                                                    onChange={(e) => {handleUserChange(u.uid, e.target.value)}}
                                                    className={classes.paidInput}
                                                />
                                            </div>

                                            {/* Status chip */}
                                            {u.hasPaid ? (
                                                <Chip icon={<CheckCircleRoundedIcon/>} label="PAGADO" color='success' variant='outlined' size="small"/>
                                            ) : (
                                                <Chip icon={<CancelRoundedIcon/>} label="NO PAGADO" color='error' variant='outlined' size="small"/>
                                            )}
                                        </div>
                                    </div>

                                    {/* Inline referral details */}
                                    <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                        <div className={classes.expandPanel}>
                                            <p className={classes.expandPanelTitle}>Referidos</p>
                                            <div className={classes.referralHeader}>
                                                <p className={classes.referralLabel}>Nombre</p>
                                                <p className={classes.referralLabel}>Email</p>
                                                <p className={classes.referralLabel}>Fecha</p>
                                                <p className={classes.referralLabel} style={{textAlign: 'center'}}>Pagado</p>
                                            </div>
                                            {userReferrals.map((r) => {
                                                const isPaid = modifiedReferrals.hasOwnProperty(r.id)
                                                    ? modifiedReferrals[r.id]
                                                    : (r.isPaid || false)
                                                return (
                                                    <div key={r.id} className={classes.referralRow}>
                                                        <p className={classes.referralText}>{r.referredNickname}</p>
                                                        <p className={classes.referralText}>{r.referredEmail}</p>
                                                        <p className={classes.referralText}>
                                                            {r.createdAt ? new Date(r.createdAt.seconds * 1000).toLocaleDateString() : '-'}
                                                        </p>
                                                        <div style={{textAlign: 'center'}}>
                                                            <Checkbox
                                                                checked={isPaid}
                                                                onChange={() => handleTogglePaid(r.id, isPaid)}
                                                                size="small"
                                                                sx={{color: 'rgba(255,255,255,0.5)', '&.Mui-checked': {color: '#4caf50'}}}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                            {Object.keys(modifiedReferrals).length > 0 && (
                                                <div className={classes.saveReferralBtn}>
                                                    <Button
                                                        onClick={handleSaveReferrals}
                                                        variant="contained"
                                                        size="small"
                                                        sx={{borderRadius: '20px', textTransform: 'none'}}
                                                    >
                                                        Guardar pagos
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    </Collapse>

                                    {/* Inline teams details */}
                                    <Collapse in={isTeamsExpanded} timeout="auto" unmountOnExit>
                                        <div className={classes.expandPanel}>
                                            {getAllTeams(u).map((t) => (
                                                <div key={t.num} className={classes.teamBlock}>
                                                    <p className={classes.teamTitle}>Equipo {t.num}</p>
                                                    <div className={classes.teamPlayersContainer}>
                                                        {t.team && t.team.map((player, pIdx) => (
                                                            <div key={pIdx} className={classes.teamPlayerContainer}>
                                                                <div
                                                                    className={classes.teamPlayerImg}
                                                                    style={{backgroundImage: `url(${player.img.startsWith('/') ? player.img : '/' + player.img})`}}
                                                                />
                                                                <p className={classes.teamPlayerName}>{player.name}</p>
                                                                <p className={classes.teamPlayerType}>{player.type}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </Collapse>
                                </div>
                            )
                        })}
                    </div>

                    {/* Save edited users */}
                    {users && users.filter(user => user.edited === true).length !== 0 && (
                        <div style={{maxWidth: 600, margin: '20px auto'}}>
                            <WhiteButton onClick={(e) => {handleSaveUsers(e)}}>Guardar cambios</WhiteButton>
                        </div>
                    )}

                    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                            {message}
                        </Alert>
                    </Snackbar>

                    {/* Reset confirmation dialog */}
                    <Dialog
                        open={confirmDialogOpen}
                        onClose={() => setConfirmDialogOpen(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"¿Estás seguro que deseas resetear todos los usuarios?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Esta acción eliminará todos los equipos y pagos de los usuarios. No se puede deshacer.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setConfirmDialogOpen(false)}>Cancelar</Button>
                            <Button onClick={handleConfirmReset} autoFocus>
                                Confirmar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </div>
        </div>
    )
}
